import { dataReportCheck } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportCheck = /*#__PURE__*/createIcon(dataReportCheck)
export default IconReportCheck
